import { NoDataException } from '../../../utils/exceptions/nodataexistsexception';
import { ChildKaroakeListDto, ChildKaroakeListDtoImpl } from './childkaroakelistdto';
import { ToneStatus } from '../../../ui/toolkit/toneoptions/tone/tonestatus';

export class GetKaroakeListBuilder
 {
    constructor(private getKaroakeList : any)
    {
        if(getKaroakeList.karoakaeList === undefined)
        {
            throw new NoDataException("Get Karoake List data doesnt exists");
        }
    }

    buildAll(): ChildKaroakeListDto[]
    {
        return this.parseGetKaroakeToneDetailsResponse();
    }

    private parseGetKaroakeToneDetailsResponse(): ChildKaroakeListDto[]
    {
        let listOfGetKaroake: ChildKaroakeListDto[] = [];
        
        let toneDto = null;
        this.getKaroakeList.karoakaeList.forEach((karoakeListItem: any) =>
        {
            toneDto = new ChildKaroakeListDtoImpl();
            toneDto.setId(karoakeListItem.toneId);
            toneDto.setToneUrl(karoakeListItem.tonePath);
            toneDto.setToneName(karoakeListItem.toneName);
            toneDto.setImgPath("");
            toneDto.setStatus(this.getStatus(karoakeListItem.status));
            
            listOfGetKaroake.push(toneDto);
        });
        return listOfGetKaroake;
    }

    private getStatus(status: string)
    {
        if(status === "P")
        {
            return ToneStatus.PENDING;
        }
        else if(status === "R")
        {
            return ToneStatus.REJECTED;
        }
        else if(status === "IA")
        {
            return ToneStatus.INACTIVE;
        }
        else
        {
            return ToneStatus.ACCEPTED;
        }
    }
}




// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/dto/getkaroakelist/getkaroakelistbuilder.ts